import { ROBOT_STATUS_DATA_KEYS } from 'Config/websocketConstants';

export const validateRobotStatusData = (newRobotStatus) => {
  for (const key of Object.values(ROBOT_STATUS_DATA_KEYS)) {
    if (!(key in newRobotStatus)) {
        return false;
    }
  }
  return true;
};